var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#fcfcfc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "user-settings-filled"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    fill: "#fcfcfc",
    transform: "translate(64.000000, 42.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.180488,213.333333 L328.181163,236.169297 C338.584391,239.846405 348.098741,245.405183 356.315274,252.43669 L376.112086,241.006655 L405.741716,292.326679 L385.957797,303.749991 C386.931071,309.018468 387.439747,314.44983 387.439747,320 C387.439747,325.550277 386.931052,330.981742 385.957741,336.250315 L405.741716,347.673321 L376.112086,398.993345 L356.315274,387.56331 C348.098741,394.594817 338.584391,400.153595 328.181163,403.830703 L328.180488,426.666667 L268.921228,426.666667 L268.920553,403.830703 C258.51771,400.153731 249.00368,394.595229 240.787356,387.564092 L220.98963,398.993345 L191.36,347.673321 L211.143975,336.250315 C210.170664,330.981742 209.661969,325.550277 209.661969,320 C209.661969,314.449479 210.170709,309.017781 211.144103,303.74899 L191.36,292.326679 L220.98963,241.006655 L240.786362,252.436758 C249.002913,245.405219 258.517291,239.846417 268.920553,236.169297 L268.921228,213.333333 L328.180488,213.333333 Z M186.666667,192 C206.101493,192 224.380148,197.091591 240.310579,206.048663 C198.959113,227.266184 170.666667,270.329064 170.666667,320 C170.666667,343.314131 176.899769,365.172443 187.790443,383.999404 L-1.42108547e-14,384 L-1.42108547e-14,307.2 C-1.42108547e-14,245.167377 47.6682427,194.586369 107.383368,192.096089 L112,192 L186.666667,192 Z M298.550858,284.444444 C278.914067,284.444444 262.995302,300.363209 262.995302,320 C262.995302,339.636791 278.914067,355.555556 298.550858,355.555556 C318.187649,355.555556 334.106413,339.636791 334.106413,320 C334.106413,300.363209 318.187649,284.444444 298.550858,284.444444 Z M149.333333,7.10542736e-15 C190.570595,7.10542736e-15 224,33.4294053 224,74.6666667 C224,114.529353 192.762078,147.096031 153.430084,149.222851 L149.333333,149.333333 C108.096072,149.333333 74.6666667,115.903928 74.6666667,74.6666667 C74.6666667,34.8039807 105.904589,2.23730242 145.236582,0.110482405 L149.333333,7.10542736e-15 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.a90d6504d3c8bc9f77dc9f9445f3e419.svg";
export { ForwardRef as ReactComponent };